import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-analyticssmssummary',
  templateUrl: './analyticssmssummary.component.html',
  styleUrls: ['./analyticssmssummary.component.css']
})
export class AnalyticssmssummaryComponent implements OnInit {
  @Input('details') details: any;
  phone_ownership: any;
  average_credit: any;
  average_income: any;
  salary_amount: any;

  constructor() {
  }

  ngOnInit() {
    //this.phone_ownership = this.details.phone_ownership.phone_ownership_credibility;
   // this.average_credit = this.details.airtime_info.airtime_monthly_average;
   // this.average_income = this.details.credit_info.average;
   // this.salary_amount = this.details.salary_info.salary_monthly_average;
  }

}
